import React from 'react'
import { DEFAULT_HOME_URL, DEFAULT_COPYRIGHT } from 'modules/constants'

const TERMS_URL = 'https://www.payhelm.com/terms-of-service/'
const PRIVACY_URL = 'https://www.payhelm.com/privacy-policy/'

interface FooterProps {
  reportTimeCost?: number | null
  loadTimeMs?: number | null
}

const Footer = ({ reportTimeCost = null, loadTimeMs = null }: FooterProps) => (
  <div className="copyright tw-flex tw-flex-wrap tw-items-center tw-justify-center tw-gap-x-1.5 tw-text-xs tw-leading-tight">
    <span>
      <a href={DEFAULT_HOME_URL} target="_blank" rel="noopener noreferrer">{DEFAULT_COPYRIGHT}</a>
      {' | '}
      <a href={TERMS_URL} target="_blank" rel="noopener noreferrer">Terms &amp; Conditions</a>
      {' | '}
      <a href={PRIVACY_URL} target="_blank" rel="noopener noreferrer">Privacy Policy</a>
    </span>
    {(reportTimeCost != null || loadTimeMs != null) && (
      <span className="tw-text-slate-400">
        {reportTimeCost != null && `Report generated in ${(reportTimeCost / 1000).toFixed(1)}s`}
        {reportTimeCost != null && loadTimeMs != null && ' | '}
        {loadTimeMs != null && `Page loaded in ${(loadTimeMs / 1000).toFixed(1)}s`}
      </span>
    )}
  </div>
)

export default Footer
